import Vue from 'vue';

import AirbnbStyleDatepicker from './vue-airbnb-style-datepicker/vue-airbnb-style-datepicker.es'
import './vue-airbnb-style-datepicker/vue-airbnb-style-datepicker.css'
Vue.use(AirbnbStyleDatepicker, {
    sundayFirst: false,
    dateLabelFormat: 'dddd, MMMM D, YYYY',
    daysShort: ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"],
    days: ["Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота", "Воскресенье"],
    monthNames: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
    texts: {
        apply: 'Применить',
        cancel: 'Отмена',
    },
    colors: {
        selected: '#FDCB14',
        inRange: '#FFE36D',
        selectedText: '#111',
        text: '#111',
        inRangeBorder: '#FDCB00',
        disabled: '#fff',
    },
})

